(function () {
    "use strict";

    var _$q, _$http, _Gon;

    var GoogleContacts = Class(function () {

        return {
            constructor: function (accessToken, existingContacts, termToSearch, currUserEmail) {
                var userContact, _i, _len;
                this.currAccessToken = accessToken;
                this.nextURL = "https://www.google.com/m8/feeds/contacts/default/full?alt=json&access_token=" + this.currAccessToken + "&v=3.0&max-results=99999";
                this.searchTerm = termToSearch;
                if (this.searchTerm != null) {
                    this.nextURL += "&q=" + this.searchTerm;
                }
                this.startingIndex = 0;
                this.contacts = this.emptyContactsCollection();
                this.userContacts = [];
                for (_i = 0, _len = existingContacts.length; _i < _len; _i++) {
                    var email = "";
                    if (existingContacts[_i].user) {
                        email = existingContacts[_i].user.email.toLowerCase();
                    } else {
                        email = existingContacts[_i].toLowerCase();
                    }
                    this.userContacts.push(email);
                }
                this.currUserEmail = currUserEmail;
            },

            emptyContactsCollection: function emptyContactsCollection() {
                return [];
            },

            getNextContacts: function (numOfResults, shouldClearCache) {
                var self = this;

                var deferred;
                if (shouldClearCache == null) {
                    shouldClearCache = false;
                }
                deferred = _$q.defer();
                if (this.hasContactsInBuffer(numOfResults)) {
                    var newNumOfResults = Math.min(numOfResults, self.contacts.length - self.startingIndex);
                    deferred.resolve({
                        search: this.searchTerm,
                        contacts: this.sliceContacts(newNumOfResults)
                    });
                    return deferred.promise;
                }
                if (this.nextURL == null) {
                    deferred.resolve(self.emptyContactsCollection());
                    return deferred.promise;
                }

                if(this.nextURL.indexOf('JSON_CALLBACK') === -1) {
                    this.nextURL += '&callback=JSON_CALLBACK';
                }

                _$http.jsonp(this.nextURL)
                    .success(function (response) {

                        if (shouldClearCache) {
                            self.contacts = self.emptyContactsCollection();
                        }

                        var _ref = self.createContactsModel(response);
                        for (var _i = 0, _len = _ref.length; _i < _len; _i++) {
                            var contact = _ref[_i];

                            if (self.userContacts.indexOf(contact.user.email.toLowerCase()) == -1) {
                                self.contacts.push(contact);
                            }
                        }
                        self.setNextUrl(response);
                        var newNumOfResults = Math.min(numOfResults, self.contacts.length - self.startingIndex);
                        deferred.resolve({
                            search: self.searchTerm,
                            contacts: self.sliceContacts(newNumOfResults)
                        });
                    })

                    .error(function (error) {
                        deferred.reject(error);
                    });

                return deferred.promise;
            },

            hasMoreContacts: function () {
                return this.nextURL != null;
            },

            hasContactsInBuffer: function () {
                return this.startingIndex < this.contacts.length;// || (this.nextURL == null);
            },

            sliceContacts: function (numOfResults) {
                var ret;
                ret = this.contacts.slice(this.startingIndex, this.startingIndex + numOfResults);
                this.startingIndex += numOfResults;
                return ret;
            },

            setNextUrl: function (args) {
                var url, _i, _len, _ref, _results;
                this.nextURL = null;
                if (args.feed.link == null) {
                    return;
                }
                _ref = args.feed.link;
                _results = [];
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    url = _ref[_i];
                    if ((url["rel"] != null) && url.rel === "next") {
                        _results.push(this.nextURL = url.href + ("&access_token=" + this.currAccessToken));
                    } else {
                        _results.push(void 0);
                    }
                }
                return _results;
            },

            createContactsModel: function (args) {
                var company, contacts, currContact, entry, notValidContacts, _i, _len, _ref;
                if ((args == null) || !args.feed) {
                    return;
                }
                contacts = this.emptyContactsCollection();
                if (!args.feed.entry) {
                    return contacts;
                }
                notValidContacts = this.getNotValidContacts(args);
                _ref = args.feed.entry;
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    entry = _ref[_i];
                    currContact = {
                        full_name: this.getName(entry),
                        email: this.getEmail(entry),
                        job_title: this.getJobTitle(entry),
                        company: {
                            company_name: this.getCompany(entry),
                            company_type: 'other',
                            address: this.getAddress(entry)
                        },
                        profile_image_url: this.getPhotoUrl(entry),
                        imported_from: "Google",
                        address: this.getAddress(entry)
                    };
                    company = currContact.company;
                    if ((company.company_name == null) || company.company_name === '') {
                        currContact.system_user_type = 'client';
                    } else {
                        currContact.system_user_type = 'vendor';
                    }
                    if (this.isContactValid(currContact, notValidContacts)) {
                        var contactModel = {};
                        contactModel.user = currContact;
                        if (this.isPreferredContact(currContact)) {
                            contacts.unshift(contactModel);
                        } else {
                            contacts.push(contactModel);
                        }
                    }
                }

                return contacts;
            },

            getAttributesIrrelevantToSort: function () {
                return ["imported_from", "profile_image_url", "system_user_type", "company_type"];
            },

            getPreferredWords: function () {
                return ["plan", "event", "wedding", "cake", "baker", "photo", "cake", "baker", "venue", "hair", "makeup", "florist", "music", "dj", "cater", "stationery", "fashion", "rental"];
            },

            checkPreferredString: function (strToCheck) {
                var word, _i, _len, _ref;
                if (!strToCheck) {
                    return;
                }
                _ref = this.getPreferredWords();
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    word = _ref[_i];
                    if ((strToCheck != null) && strToCheck.toLowerCase().indexOf(word) > -1) {
                        return true;
                    }
                }
            },

            isPreferredContact: function (contact) {
                var key, objToCheck, strToCheck;
                for (key in contact) {
                    if (this.getAttributesIrrelevantToSort().indexOf(key) !== -1) {
                        continue;
                    }
                    objToCheck = contact[key];
                    if (typeof objToCheck === 'string') {
                        if (this.checkPreferredString(objToCheck)) {
                            return true;
                        }
                    } else {
                        for (key in objToCheck) {
                            strToCheck = objToCheck[key];
                            if (this.checkPreferredString(strToCheck)) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            },

            getNotValidContacts: function (args) {
                var currUserEmail;
                currUserEmail = '';
                if ((args.feed.author != null) && (args.feed.author[0] != null) && (args.feed.author[0].email != null)) {
                    currUserEmail = args.feed.author[0].email['$t'];
                }
                return [currUserEmail, this.currUserEmail];
            },

            isContactValid: function (contact, notValidContacts) {
                var currEmail;
                currEmail = contact.email;
                return (currEmail != null) && currEmail.trim() !== '' && !_.contains(notValidContacts, currEmail.toLowerCase());
            },

            getName: function (entry) {
                if (entry.gd$name == null) {
                    return '';
                }
                if (entry.gd$name.gd$fullName != null) {
                    return entry.gd$name.gd$fullName["$t"];
                }
                if (entry.title != null) {
                    return entry.title["$t"];
                }
                return '';
            },

            getCompany: function (entry) {
                if ((entry.gd$organization == null) || (entry.gd$organization[0].gd$orgName == null)) {
                    return 'TBD';
                }
                return entry.gd$organization[0].gd$orgName["$t"];
            },

            getJobTitle: function (entry) {
                if ((entry.gd$organization == null) || (entry.gd$organization[0].gd$orgTitle == null)) {
                    return '';
                }
                return entry.gd$organization[0].gd$orgTitle["$t"];
            },

            getEmail: function getEmail(entry) {
                if (entry.gd$email == null) {
                    return '';
                }
                if ((entry.gd$email[0] != null) && (entry.gd$email[0].address != null)) {
                    return entry.gd$email[0].address;
                }
                return '';
            },

            getAddress: function (entry) {
                if ((entry.gd$structuredPostalAddress != null) && (entry.gd$structuredPostalAddress[0] != null) && (entry.gd$structuredPostalAddress[0].gd$formattedAddress != null) && entry.gd$structuredPostalAddress[0].gd$formattedAddress.$t) {
                    return entry.gd$structuredPostalAddress[0].gd$formattedAddress.$t.replace(/\n/g, ',');
                }
                return '';
            },

            getPhotoUrl: function getPhotoUrl(entry) {
                var url, _i, _len, _ref;
                if (!entry["link"]) {
                    return '';
                }
                _ref = entry.link;
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    url = _ref[_i];
                    if ((url["type"] != null) && url.type === "image/*" && (url["gd$etag"] != null)) {
                        return url.href + ("&access_token=" + this.currAccessToken);
                    }
                }
                return '';
            }
        };
    });

    Services.GAPI = {
        isInitSuccess: false,
        isInitProgress: false,
        fetched: false,
        resolver: {
            // the resolver insures that the google API will be loaded before the controller
            // is instantiated and the GoogleAPIService is injected to it. GoogleAPIService
            // needs the gapi to be ready before it's constructor is ran.
            // with this new approach the only route that will need the resolver is the login routes.
            gapi:  ['$q', function ($q) {
                if (!_$q) {
                    _$q = $q;
                }
                return Services.GAPI.loadClientAuth();
            }]
        },

        loadClientAuth: function () {
            if (!Services.GAPI.deferred) {
                Services.GAPI.deferred = _$q.defer();
            }
            // if google code is fetched and we didn't already init or in the middle of init
            if (Services.GAPI.fetched && !Services.GAPI.isInitSuccess && !Services.GAPI.isInitProgress) {
                gapi.load('client:auth2', Services.GAPI.initAuth);
            }
            return Services.GAPI.deferred.promise;
        },

        onGAPILoaded: function () {
            Services.GAPI.fetched = true;
        },

        initAuth: function initAuth() {
            Services.GAPI.isInitProgress = true;

            // Get authorization from the user to access profile info
            gapi.client.setApiKey(_Gon.google_api_api_key);

            // Call init
            gapi.auth2.init({
                client_id: _Gon.google_api_client_id,
                scope: 'profile email'
            }).then(function(){
                Services.GAPI.isInitSuccess = true;
                Services.GAPI.isInitProgress = false;
                if (Services.GAPI.deferred) {
                    Services.GAPI.deferred.resolve(window.gapi);
                }
            });

            // DO NOT WAIT FOR GOOGLE FOR TOO LONG!
            setTimeout(function () {
                if (!Services.GAPI.isInitSuccess) {
                    Services.GAPI.deferred.resolve(window.gapi);
                }
            }, 3000);

        }
    };

    //this is necessary to be on the window otherwise the google's client.js (found on the angular.html.erb) will not call it using the onLoad callback.
    window.onGAPILoaded = Services.GAPI.onGAPILoaded;

    // @ngInject
    function GoogleAPIServiceCtor($http, $q, Gon, $log, moment, Routes) {
        _$q = $q;
        _$http = $http;
        _Gon = Gon;
        this.$log = $log;
        this.moment = moment;
        this.Routes = Routes;
    }

    Services.GoogleAPIService = Class(function () {

        var service = {

            connect: function (scope, shouldOpenPopup) {
                var deferred = _$q.defer();
                if (!gapi.auth2) {
                    this.$log.error("couldn't connect to google");
                    deferred.reject("couldn't connect to google");
                    return deferred.promise;
                }
                var googleAuth = gapi.auth2.getAuthInstance();
                if(!shouldOpenPopup) {
                    // check if user is already signed in and with granted scope
                    if(googleAuth.isSignedIn.get()) {
                        var googleUser = googleAuth.currentUser.get();
                        if(googleUser.hasGrantedScopes(scope)) {
                            deferred.resolve(googleUser.getAuthResponse().access_token);
                        } else {
                            deferred.reject("User is missing google permissions");
                        }
                    } else {
                        deferred.reject("User is not connected to google");
                    }
                } else if (googleAuth.isSignedIn.get()) {
                    // user is already sign in with google account and only needs permissions for scope
                    this.grantScopes(scope).then(
                        function (success) {
                            deferred.resolve(success.access_token);
                        },
                        function (fail) {
                            deferred.reject(fail);
                        });
                } else {
                    // sign in with scope permissions
                    var options = new gapi.auth2.SigninOptionsBuilder(
                        {'scope': scope});
                    this.signIn(options).then(
                        function (success) {
                            deferred.resolve(success.getAuthResponse().access_token);
                        },
                        function (fail) {
                            deferred.reject(fail);
                        });
                }

                return deferred.promise;
            },

            grantScopes: function grantScope(scopes) {
                var options = new gapi.auth2.SigninOptionsBuilder(
                    {'scope': scopes});
                var googleAuth = gapi.auth2.getAuthInstance();
                var deferred = _$q.defer();
                var googleUser = googleAuth.currentUser.get();
                googleUser.grant(options).then(
                    function(success){
                        deferred.resolve(success);
                    },
                    function(fail){
                        deferred.reject(fail);
                    });
                return deferred.promise;
            },

            signIn: function signIn(options) {
                if(!options) {
                    options = new gapi.auth2.SigninOptionsBuilder(
                        {'scope': 'profile email'});
                }
                var deferred = _$q.defer();
                try {
                    var googleAuth = gapi.auth2.getAuthInstance();
                    googleAuth.signIn(options).then(function() {
                        var googleUser = googleAuth.currentUser.get();
                        deferred.resolve(googleUser);
                    }, function(res) {
                        deferred.reject(res);
                    });
                } catch (e) {
                    deferred.reject(e);
                }
                return deferred.promise;
            },

            signOut: function signOut() {
                var deferred = _$q.defer();
                if(gapi.auth2) {
                    var googleAuth = gapi.auth2.getAuthInstance();
                    if(googleAuth) {
                        googleAuth.signOut().then(function(resp) {
                            deferred.resolve(resp);
                        }, function(resp) {
                            deferred.reject(resp);
                        });
                    } else {
                        deferred.reject('GoogleAuth is missing');
                    }
                } else {
                    deferred.reject('Google API not initialized');
                }
                return deferred.promise;
            },

            getContactsAPI: function (existingContacts, shouldOpenPopup, timeout_millis) {
                if (shouldOpenPopup == null) {
                    shouldOpenPopup = true;
                }
                if (timeout_millis == null) {
                    timeout_millis = 45000;
                }
                return this.searchContactsAPI(existingContacts, shouldOpenPopup, void 0, timeout_millis);
            },

            searchContactsAPI: function (existingContacts, shouldOpenPopup, termToSearch, timeout_millis) {
                var self = this;
                var deferred, timeout;
                if (termToSearch == null) {
                    termToSearch = void 0;
                }
                if (timeout_millis == null) {
                    timeout_millis = 45000;
                }
                deferred = _$q.defer();
//                timeout = setTimeout(function () {
//                    deferred.reject('DASHBOARD.CONTACTS.GOOGLE.GOOGLE_API._TIMEOUT_ERROR_');
//                }, timeout_millis);
                this.connect('https://www.googleapis.com/auth/contacts.readonly', shouldOpenPopup).then(function success(accessToken) {
                    var contacts;
//                    clearTimeout(timeout);
                    var googleAuth = gapi.auth2.getAuthInstance();
                    var googleUser = googleAuth.currentUser.get();
                    contacts = new GoogleContacts(accessToken, existingContacts, termToSearch, googleUser.getBasicProfile().getEmail);
                    deferred.resolve(contacts);
                }, function fail(res) {
//                    clearTimeout(timeout);
                    if ((res != null) && res.error) {
                        deferred.reject(res.error);
                    } else {
                        deferred.reject('DASHBOARD.CONTACTS.GOOGLE.GOOGLE_API._UNKNOWN_ERROR_');
                    }
                });
                return deferred.promise;
            }
        };

        function ensureGoogleIsLoaded(callback) {
            return function () {
                if (Services.GAPI.isInitSuccess) {
                    return callback.apply(this, arguments);
                } else {
                    // init google
                    Services.GAPI.loadClientAuth();
                    // wrap
                    return Services.GAPI.deferred.promise.then(function () {
                        return callback.apply(this, arguments);
                    }.bind(this));
                }
            };
        }

        return {
            constructor: GoogleAPIServiceCtor,
            connect: ensureGoogleIsLoaded(service.connect),
            grantScopes: ensureGoogleIsLoaded(service.grantScopes),
            signIn: ensureGoogleIsLoaded(service.signIn),
            signOut: ensureGoogleIsLoaded(service.signOut),
            getContactsAPI: ensureGoogleIsLoaded(service.getContactsAPI),
            searchContactsAPI: ensureGoogleIsLoaded(service.searchContactsAPI)
        };
    });
}());